export default "__VITE_ASSET__983c209e__"